import type { CandleWithFlag } from "features/chart";

export interface AroonLines {
  up: (number | null)[];
  down: (number | null)[];
}

export function calcAroon(data: CandleWithFlag[], period: number): AroonLines {
  const n = data.length;
  const up: (number | null)[] = new Array(n).fill(null);
  const down: (number | null)[] = new Array(n).fill(null);

  for (let i = period; i < n; i++) {
    let highIdx = i, lowIdx = i;
    for (let j = i - period; j < i; j++) {
      if (!("high" in data[j])) continue;
      if (data[j].high > data[highIdx].high) highIdx = j;
      if (data[j].low < data[lowIdx].low) lowIdx = j;
    }
    up[i] = ((period - (i - highIdx)) / period) * 100;
    down[i] = ((period - (i - lowIdx)) / period) * 100;
  }

  return { up, down };
}
